import { lazyRoute } from '@eluve/app-router-utils';

/*
 * These route objects are spread into route tables that are themselves loaded
 * at app startup, so the pages behind them are deferred individually — the
 * table needs the paths, not the page code.
 */
const CreateOutputTemplatePage = lazyRoute(
  'CreateOutputTemplatePage',
  () => import('./CreateOutputTemplatePage'),
);
const CloneOutputTemplatePage = lazyRoute(
  'CloneOutputTemplatePage',
  () => import('./CloneOutputTemplatePage'),
);
const CreateOutputTemplateVariantPage = lazyRoute(
  'CreateOutputTemplateVariantPage',
  () => import('./CreateOutputTemplateVariantPage'),
);
const OutputTemplateDetailsPage = lazyRoute(
  'OutputTemplateDetailsPage',
  () => import('./OutputTemplateDetailsPage'),
);

export const outputTemplateRoutes = [
  {
    path: 'create',
    element: <CreateOutputTemplatePage />,
  },
  {
    path: 'clone/:outputTemplateId',
    element: <CloneOutputTemplatePage />,
  },
  {
    path: 'clone/:outputTemplateId/variant/:variantNumber',
    element: <CreateOutputTemplateVariantPage />,
  },
  {
    path: 'edit/:outputTemplateId/variant/:variantNumber',
    element: <CreateOutputTemplateVariantPage />,
  },
  {
    path: ':outputTemplateId',
    element: <OutputTemplateDetailsPage />,
  },
  {
    path: ':outputTemplateId/variant/:variantNumber',
    element: <OutputTemplateDetailsPage />,
  },
];
